


























import { Component, Vue, Ref } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { UserModule } from "@/store/modules/UserModule";
import router from "@/router/router";
import {
  doesClientHaveApp,
  getClientId,
} from "@/data/repository/ClientRepository";
import { NewProjectScope } from "@/data/repository/ProjectRepository";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class SelectProjectTypeComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  canCreateLeakDetectionProjects = true;
  canCreateDryingProjects = true;
  canCreateMixedProjects =
    [
      "sfztT2VTtAeNOpcgmdWuIQea4Ve2",
      "PBjjc8sx8JNF1aZacNph2Z1aRSj1",
      "8kuGPeUPQ5RhThIvbOxK76woA482",
      "fShWscQ6V3OykYHGBvU1wxmz1So2",
    ].indexOf(getClientId()) >= 0;

  get canOnlyCreateSingleProjectType() {
    return (
      [
        this.canCreateMixedProjects,
        this.canCreateDryingProjects,
        this.canCreateLeakDetectionProjects,
      ].filter((value) => value).length <= 1
    );
  }

  show() {
    this.canCreateDryingProjects = UserModule.hasActiveUserDryingProjectLicence;
    this.canCreateLeakDetectionProjects =
      UserModule.hasActiveUserLeakDetectionProjectLicence &&
      doesClientHaveApp();

    if (this.canOnlyCreateSingleProjectType) {
      this.onCreateProject(this.canCreateLeakDetectionProjects ? 0 : 1, false);
    } else {
      this.baseDialogComponent.show({
        title: this.$t("clientData.createProject").toString(),
        maxWidth: 400,
        positiveButtonText: null,
      });
    }
  }

  onCreateProject(projectType: number, directOrder: boolean) {
    const newProjectScope =
      projectType === 0
        ? NewProjectScope.LEAK_DETECTION
        : projectType === 1
        ? NewProjectScope.DRYING
        : NewProjectScope.FLEX;

    router.push({
      path: "createProject",
      query: {
        directOrder: directOrder ? "1" : null,
        newProjectScope: newProjectScope,
      },
    });
  }
}
